/**
 * Replaces positional "{0}", "{1}", ... placeholders in a template string with the given values,
 * e.g. formatTemplate('Product image {0} of {1}', ['1', '3']).
 */
export function formatTemplate(template: string, values: Array<string | number>): string {
  let result = template
  for (const [index, value] of values.entries()) {
    result = result.split(`{${index}}`).join(String(value))
  }
  return result
}

export function buildImageAriaLabel(template: string, index: number, total: number): string {
  return formatTemplate(template, [index + 1, total])
}
